import { SPACE } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-select-with-search',
  templateUrl: './select-with-search.component.html',
  standalone: false
})
export class SelectWithSearchComponent implements OnInit, OnChanges {
  @Input() formGroup!: FormGroup;
  @Input() sourcData!: any[];
  @Input() isSubmitted!: boolean;
  @Input() controlName!: any
  @Input() fieldLabel!: String;
  @Input() multiple: boolean = true;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() dataLoading: boolean = false;
  @Input() hidden: boolean = false;
  @Input() key: string = 'name';
  //
  @ViewChild('searchInput', { static: false })
  searchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('select', { static: true }) select: any;
  //
  hiddenList: any[] = [];
  @Output() selectionChangeEvent = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    this.select._handleKeydown = (event: KeyboardEvent) => {
      if (event.keyCode == SPACE)
        return
      if (!this.select.disabled) {
        this.select.panelOpen
          ? this.select._handleOpenKeydown(event)
          : this.select._handleClosedKeydown(event);
      }
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['isSubmitted'] && changes['isSubmitted'].currentValue) {
      this.formGroup.controls[this.controlName].markAllAsTouched();
    }
  }

  applyFilter(value: string) {
    const filterValue = value.toLowerCase();
    this.hiddenList = [];
    this.sourcData.forEach((item) => {
      if (filterValue && !(this.key ? String(item[this.key]) : item).toLowerCase().includes(filterValue)) {
        this.hiddenList.push(item);
      }
    });
  }

  selectValue(event: any) {
    const keyboardEvent = event as KeyboardEvent;
    // Get only visible items (those NOT in hiddenList)
    const visibleItems = this.sourcData.filter(
      item => !this.hiddenList.some(obj =>
        (this.key ? obj[this.key] : obj) === (this.key ? item[this.key] : item)
      )
    );

    // If there is exactly 1 visible result → select it
    if (visibleItems.length === 1) {
      this.formGroup.controls[this.controlName].setValue(visibleItems[0]);
      this.selectionChangeEvent.emit(true);
      // Close the mat-select panel
      if (this.select && this.select.close) {
        this.select.close();
      }
    } else {
      keyboardEvent.preventDefault();
      keyboardEvent.stopPropagation();
    }

    // Otherwise → do nothing (no random selection)
  }

  openEvent(opened: boolean) {
    if (opened) {
      setTimeout(() => this.searchInput.nativeElement.focus());
    } else {
      this.searchInput.nativeElement.value = '';
      this.applyFilter('');
    }
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  isInArray(parentObj: any, name: string) {
    return parentObj.some((obj: any) => (this.key ? obj[this.key] : obj) === name);
  }
}
